import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useContext } from 'react';
import { Icon } from '../../icon/index.js';
import { DialogTitleStyled, CloseButton } from './style.js';
import { DialogContext } from './DialogContext.js';

var DialogTitle = function DialogTitle(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  var dialogState = useContext(DialogContext).dialogState;
  return /*#__PURE__*/React.createElement(DialogTitleStyled, __assign({
    theme: dialogState.theme,
    fcStyle: dialogState.fcStyle
  }, rest), children, /*#__PURE__*/React.createElement(CloseButton, {
    theme: dialogState.theme,
    title: "Close dialog",
    "aria-label": "Close",
    onClick: function onClick() {
      return dialogState.onCloseClick();
    },
    ref: dialogState.closeButton
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "times",
    title: "Close"
  })));
};

export { DialogTitle };